<div class="kpi-card">
  <div class="kpi-icon" [style.background]="iconBg" [style.color]="iconColor">
    <i [class]="icon"></i>
  </div>
  <div class="kpi-label">{{ label }}</div>
  <div class="kpi-value">{{ value }}</div>
  <div class="kpi-change"><i class="bi bi-arrow-up"></i> {{ change }}</div>
</div>
